"use client";

import React from 'react';
import MainLayout from '@/layouts/MainLayout';
import FAQ from '@/components/FAQ';

const FAQPage: React.FC = () => {
  return (
    <MainLayout>
      <div className="py-16">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h1 className="text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#49A8FF] via-[#FD89E8] to-[#FFB64F] mb-6">
            Have Questions?
          </h1>
          <p className="text-muted-foreground text-lg font-bold">
            Find some answers here 👇 or <a href="mailto:aayush@saved.gg" className="text-foreground hover:text-primary transition-colors duration-200">reach out directly</a>
          </p>
        </div>
        <FAQ />
      </div>
    </MainLayout>
  );
};

export default FAQPage;